import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import { memo } from 'react';
import { ColumnNameProps } from '../../modules/communities/models/communities.types';
import { ImageFallback } from '../../shared/components/ImageFallback/ImageFallback';
import { useShared } from '../../shared/hooks/use-shared.hook';
import { ImageFallbackType } from '../../shared/models/shared.types';

const ColumnName = memo((props: GridRenderCellParams<ColumnNameProps>) => {
  const { fullNameGet } = useShared();
  return (
    <div className="flex items-center gap-4 pl-2 text-xs">
      <div className="flex items-center relative">
        {props.row?.avatar?.url ? (
          <img
            alt={props.row?.name}
            className="h-9 rounded-full object-cover w-9"
            src={props.row.avatar.url}
          />
        ) : (
          <ImageFallback
            sizeClassName="h-9 rounded-full object-cover w-9"
            type={ImageFallbackType.Profile}
          />
        )}
      </div>
      <div className="text-xs">
        {fullNameGet(
          props.row?.first_name,
          props.row?.last_name,
          props.row?.nickname
        )}
      </div>
    </div>
  );
});

export default ColumnName;
